import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=53915f10&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53915f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53915f10')) {
      api.createRecord('53915f10', component.options)
    } else {
      api.reload('53915f10', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=53915f10&scoped=true&", function () {
      api.rerender('53915f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KcPYL7hylPi3/JS/comp/Accordion.vue"
export default component.exports